export const DonationsTags = {
  ActiveDonations: 'ActiveDonations',
  DonationHistory: 'DonationHistory',
} as const;

export type DonationsTagType = (typeof DonationsTags)[keyof typeof DonationsTags];
